import script from "./Background.vue?vue&type=script&lang=ts&setup=true"
export * from "./Background.vue?vue&type=script&lang=ts&setup=true"

import "./Background.vue?vue&type=style&index=0&id=4691734d&lang=css"
import "./Background.vue?vue&type=style&index=1&id=4691734d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4691734d"]])

export default __exports__